import React, { useCallback } from "react";
import { Avatar } from "../ui/Avatar";
import { Badge } from "../ui/Badge";
import { useCurrentEventDay } from "../../hooks/use-current-event-day";
import { DISABLE_CLEAR_BUTTON } from "../../infra/settings";

export const Header: React.FC = () => {
  const currentDay = useCurrentEventDay();

  const handleReset = useCallback(() => {
    localStorage.removeItem("messages");
    localStorage.removeItem("threadId");
    localStorage.removeItem("chatInitied");
    Object.keys(localStorage)
      .filter((k) =>
        k.startsWith("prizeCard_") || k.startsWith("questionSingleResponse_")
      )
      .forEach((k) => localStorage.removeItem(k));
    window.location.reload();
  }, []);

  return (
    <div className="sticky top-0 z-10 bg-white border-b border-grey-91 shadow-sm">
      <div className="flex items-center px-4 py-3 gap-3">
        <Avatar />
        <div className="flex-1 min-w-0">
          <p className="text-navy font-bold text-sm leading-tight">
            CI&T Assistant
          </p>
          <p className="text-navy-41 text-xs leading-tight">
            11th Annual Becker's IT + Revenue Cycle Conference · Booth #5318
          </p>
        </div>
        {currentDay && <Badge text={currentDay} />}
        {!DISABLE_CLEAR_BUTTON && (
          <button
            onClick={handleReset}
            aria-label="Reset chat"
            className="text-navy-64 hover:text-navy transition-colors p-1"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
